import React, { useEffect } from "react"
import { Box, Skeleton, Typography } from "@mui/material"
import { useLocation, useSearchParams } from "react-router-dom"

import { ONE_WAY_ROUTES } from "@constants"
import { AppOfficesBlock } from "@components"
import { offices, reports, searchID } from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import ReportsAutocomplete from "Pages/@PageWrapper/Actions/Reports"
import { resetCustomFilters } from "Pages/AnalyzersV2/@signals"
import { useSearchDate } from "Pages/AnalyzersV2/@hooks"
import OneWayContent from "Pages/AnalyzersV2/OneWay/Content"
import OneWayFilters from "Pages/AnalyzersV2/OneWay/Filters"
import { resetOneWayData } from "Pages/AnalyzersV2/OneWay/@signals"
import { dsColorNew } from "@palette"


export default function OneWayAnalyzer() {

	const [ searchParams ] = useSearchParams()
	const location = useLocation()
	const { date, office, isLoading } = useSearchDate()

	useEffect(() => {
		resetCustomFilters()
		resetOneWayData()
		searchID.value = searchParams.get("idSearch")
		reports.value = searchParams.get("idReportExecution")
		offices.value = searchParams.get("idOfficePickup")
	}, [location.search])

	useEffect(() => resetOneWayData, [])

	return <PageWrapper
		head={`DS Rentacar | ${ONE_WAY_ROUTES.ANALYZER_TITLE}`}
		title={ONE_WAY_ROUTES.TITLE}
		subtitle={ONE_WAY_ROUTES.ANALYZER_TITLE}
		isEmpty={false}
		filters={<OneWayFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, whiteSpace: 'nowrap' }}>
			{!searchID.value && <Box sx={{ minWidth: { xs: 240, xl: 300 }, mr: { xs: 0.5, xl: 2 } }}>
				<ReportsAutocomplete filters={{ onlyOneWay: true }}/>
			</Box>}
			{!!searchID.value && <>
				{isLoading
					? <Skeleton variant='rounded' height={30} sx={{ borderRadius: '8px' }}/>
					: <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, color: dsColorNew.textMuted }}>
						<AppOfficesBlock sx={{ color: dsColorNew.black }} {...office} /> -
						<Typography variant="subtitle2" fontWeight='regular'>{date}</Typography>
					</Box>}
			</>}
		</Box>}
	>
		<OneWayContent/>
	</PageWrapper>
}